import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Wrapper } from 'src/app/components/wrapper.component';
import { environment } from '../../../environments/environment';
import { Budget, BudgetRevenueShare } from '../../store/reselectors/budget.data';
import { BudgetSnapshotDialogData } from './costs-view-dialog.component';
import { publicHelpers } from './../../helpers/public-helpers';
import { brandDataReselector } from '../../store/reselectors/publish.reselector';
import { generateEmailLink } from '../../helpers/helpers';
import { ItemStatus } from 'globals/store/share.data';
import { BrandingData, BrandingSelectData } from 'globals/store/publish.data';
import { JoiEvent } from 'globals/store/events.data';
import { compactDate, str2Date } from 'globals/helpers/helpers';
import { BigDialogWrapperComponent } from 'src/app/components/wrappers/big-dialog-wrapper.component';
import { CommonModule } from '@angular/common';
import { ShareCodeComponent } from '../share/share-code.component';
import { BudgetRevenueShareViewComponent } from './revenue-share-view.component';

@Component({
    selector: 'manage-revenue-share',
    templateUrl: './manage-revenue-share.html',
    styleUrls: ['./manage-revenue-share.scss'],
    standalone: true,
    imports: [BigDialogWrapperComponent, CommonModule, ShareCodeComponent, BudgetRevenueShareViewComponent],
})
export class ManageRevenueShareDialogComponent extends Wrapper<ManageRevenueShareDialogComponent>  {

  deleteText = 'Are you sure you want to delete this snapshot of the budget?'
  budget: BudgetRevenueShare
  fullBudget: Budget
  loading = false
  baseUrl = environment.joi.shareBase
  statusOptions: ItemStatus[] = ['Active', 'Off']
  readonly api = `${environment.functionsURL}api/app`;
  brandingData: BrandingData
  event: JoiEvent

  constructor(public dialogRef: MatDialogRef<ManageRevenueShareDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: BudgetSnapshotDialogData) {
    super()
    this.subProp(this.store.select('budget', 'budget'), 'fullBudget')
    this.subProp(this.store.select('events', 'event'), 'event')
    this.downloadSnapshot()
    const brandingSelectData: BrandingSelectData = {
      type: 'forms',
      brandFormType: 'revenue'
    }
    this.selectProp(brandDataReselector, brandingSelectData, 'brandingData')
  }

  emailGenerator(publishCode: string) {
    const firstDate = this.event.first_date
    const dateText = firstDate ? `, ${compactDate(str2Date(firstDate))}` : ''
    const title = this.event.title || 'untitled event'
    const subject = `Information for ${title}${dateText}`
    const body = `Hi there,\n\nPlease click on the link below to view the budget for ${title}${dateText}.\n\n${publishCode}\n\nThanks`
    return generateEmailLink(subject, body)
  }

  exit() {
    this.dialogRef.close()
  }

  print(shareUrl: string) {
    const fullUrl = `${shareUrl}?print=true`
    console.log({ fullUrl })
    publicHelpers.openInNewTab(fullUrl)

  }

  async changeStatus() {
    const info = this.fullBudget.revenueSnapshots.find(s => s.id === this.data.info.id)
    info.active = !info.active
    this.data.info.active = info.active
    await this.budgetService.updateBudget(this.data.eventId, this.fullBudget)
  }

  async downloadSnapshot() {
    this.loading = true
    const url = `${this.api}/load-budget-snapshot` // need to create
    const filePath = `revenueSnapshots/${this.data.eventId}/${this.data.info.id}`
    try {
      const data = await this.take1(this.http.post(url, { filePath })) as BudgetRevenueShare
      console.log({ data })
      if (!data) {
        console.log("NO DATA!")
        return
      }
      this.budget = data
    } catch (error) {
      console.log(error)
    } finally {
      this.loading = false
    }

  }

  async delete() {
    this.fullBudget.revenueSnapshots = this.fullBudget.revenueSnapshots.filter(s => s.id !== this.data.info.id)
    await this.budgetService.updateBudget(this.data.eventId, this.fullBudget)
    this.exit()
  }

}

